import { Link } from "react-router-dom";

// "Nothing here" state for lists and pages. Not an error page: e.g. a brand
// whose ads have all expired simply has nothing to show right now.
const DataNotFound = ({ hideTopBar, title = "Sem resultados", message = "Não encontrámos o que procura.", showAllLink = false }) => {
    return (
        <div>
            <main>

                {/* <!-- Breadcrumbs --> */}
                {
                    !hideTopBar && <div className="b-crumbs-wrap">
                        <div className="cont b-crumbs">
                            <ul>
                                <li>
                                    <Link to="/">Motor</Link>
                                </li>
                                <li>
                                    <span>{title}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                }

                <div className="cont maincont">
                    <div className="pagecont" style={{ textAlign: 'center', padding: '40px 16px 60px' }}>
                        <i className="fa fa-search" style={{ fontSize: 46, color: '#c9c9c9' }}></i>
                        <h3 className="heading-font" style={{ marginTop: 16, marginBottom: 8 }}>{title}</h3>
                        <p style={{ color: '#777', marginBottom: 20 }}>{message}</p>
                        {showAllLink && <Link to="/products" className="om-button">Ver todos os anúncios</Link>}
                    </div>
                </div>

            </main>
        </div>
    );
}

export default DataNotFound;
